import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {
  IDiscountList, IMerchandiseList, ICustomerType, IAccType, IMerchandisePack, ISaveDeleteResponse,
  IRentalDiscountDetails, IMerchandisDiscountDetails
} from '../Shared/interface';
import {AppInsightsService} from './app-insights.service';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root',
})

export class DiscountsService {

  // private baseURL = 'http://localhost:64651/api';
  private baseURL = this.appService.config.apiBaseUrl;

  constructor(private http: HttpClient,
              private appinsights: AppInsightsService,
              private appService: AppService) {
  }

  updateRentalDiscountDetails(rentDisc: IRentalDiscountDetails): Observable<boolean> {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    let url = '';
    if (rentDisc.Id === 0) {
      url = `${this.baseURL}/discounts/CreateDiscount`;
    } else {
      url = `${this.baseURL}/discounts/UpdateDiscount`;
    }
    return this.http.post<ISaveDeleteResponse>(url, rentDisc, options)
      .pipe(
        map(res => {
          return res.Success;
        }),
        catchError(this.handleError)
      );
  }

  updateMerchandiseDiscountDetails(merchDisc: IMerchandisDiscountDetails): Observable<boolean> {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    let url = '';
    if (merchDisc.Id === 0) {
      url = `${this.baseURL}/discounts/CreateMerchandiseDiscount`;
    } else {
      url = `${this.baseURL}/discounts/UpdateMerchandiseDiscount`;
    }
    return this.http.post<ISaveDeleteResponse>(url, merchDisc, options)
      .pipe(
        map(res => {
          return res.Success;
        }),
        catchError(this.handleError)
      );
  }

  getRentalDiscountDetails(Id: number): Observable<IRentalDiscountDetails> {
    return this.http.get<IRentalDiscountDetails>(
      `${this.baseURL}/discounts/GetDiscountDetails?discountId=${Id}`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const rentDiscDetails = res.body as IRentalDiscountDetails;
          return rentDiscDetails;
        }),
        catchError(this.handleError)
      );
  }

  getMerchandiseDiscountDetails(Id: number): Observable<IMerchandisDiscountDetails> {
    return this.http.get<IMerchandisDiscountDetails>(
      `${this.baseURL}/discounts/GetMerchandiseDiscountDetails?merchandiseDiscountId=${Id}`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const merchDiscDetails = res.body as IMerchandisDiscountDetails;
          return merchDiscDetails;
        }),
        catchError(this.handleError)
      );
  }

  deleteDiscount(Id: number,ConnectionId: string) {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/discounts/DeleteDiscounts?discountId=${Id}&connectionId=${ConnectionId}`, options);
  }

  deleteMerchandiseDiscount(Id: number,ConnectionId: string) {
    const options = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    return this.http.post<ISaveDeleteResponse>(
      `${this.baseURL}/discounts/DeleteMerchandiseDiscounts?merchandiseDiscountId=${Id}&connectionId=${ConnectionId}`, options);
  }

  getIsDiscountNameExist(Name: string): Observable<boolean> {
    return this.http.get<any>(
      `${this.baseURL}/discounts/IsDiscountExist?discountName=${Name}`,
      {observe: 'response'})
      .pipe(
        map(result => {
          let isExist: boolean;
          const NameExist = result.body as any;
          if ((typeof NameExist === 'undefined') || (NameExist === null)) {
            isExist = false;
            return isExist;
          } else {
            return NameExist;
          }
        }),
        catchError(this.handleError)
      );
  }

  getIsMerchDiscountNameExist(Name: string): Observable<boolean> {
    return this.http.get<any>(
      `${this.baseURL}/discounts/IsMerchandiseDiscountExist?merchandiseDiscountName=${Name}`,
      {observe: 'response'})
      .pipe(
        map(result => {
          let isExist: boolean;
          const NameExist = result.body as any;
          if ((typeof NameExist === 'undefined') || (NameExist === null)) {
            isExist = false;
            return isExist;
          } else {
            return NameExist;
          }
        }),
        catchError(this.handleError)
      );
  }

  getDiscountsList(): Observable<IDiscountList[]> {
    return this.http.get<IDiscountList[]>(
      `${this.baseURL}/discounts/GetDiscounts`,
      {observe: 'response'})
      .pipe(
        map(res => {
          const reportGroup = res.body as IDiscountList[];
          return reportGroup;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
